import { useState, useEffect } from 'react';
import { PricingResponse } from '../api/Requests';
import { useConfig } from './useConfig';

type BillingPeriod = 'monthly' | 'annual';

export function usePaymentLink(
  userId: string | undefined,
  userEmail: string | undefined,
  billingPeriod: BillingPeriod,
  pricingInfo: PricingResponse | null
) {
  const config = useConfig();
  const [paymentLink, setPaymentLink] = useState('');

  useEffect(() => {
    if (!userId || !userEmail || !pricingInfo) return;

    const monthlyPaymentLinkBaseUrl = config.PREMIUM_SUBSCRIPTION_PAYMENT_LINK_MONTHLY 
      || config.PREMIUM_SUBSCRIPTION_PAYMENT_LINK;
    const annualPaymentLinkBaseUrl = config.PREMIUM_SUBSCRIPTION_PAYMENT_LINK_ANNUAL 
      || config.PREMIUM_SUBSCRIPTION_PAYMENT_LINK;
    const promotionCode = config.PREMIUM_SUBSCRIPTION_PROMOTION_CODE;

    const baseUrl = billingPeriod === 'annual' && annualPaymentLinkBaseUrl
      ? annualPaymentLinkBaseUrl 
      : monthlyPaymentLinkBaseUrl;
    
    if (baseUrl) {
      let link = `${baseUrl}?client_reference_id=${userId}&prefilled_email=${userEmail}`;
      if (promotionCode) {
        link += `&prefilled_promo_code=${promotionCode}`;
      }
      setPaymentLink(link);
    }
  }, [userId, userEmail, billingPeriod, pricingInfo, config]);

  return paymentLink;
}

